<mat-dialog-content class="dialog-body">
    <h3>Wybierz publikacje</h3>
</mat-dialog-content>
<mat-dialog-actions align="start">
    <div class="publication-list-dialog__list">
        @for (publication of publications$ | async; track publication.id) {
            <div class="publication-list-dialog__item">
                <p class="publication-list-dialog__item-title">
                    {{ publication.name }}
                </p>
                <p class="publication-list-dialog__item-description">
                    {{ publication.description }}
                </p>
                <button
                    mat-flat-button
                    [mat-dialog-close]="publication.id"
                >
                    Wybierz
                </button>
            </div>
        }
    </div>
</mat-dialog-actions>
